import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './styles'
import './scripts'
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './hoc';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
